import { combineReducers } from "redux";

import { IAsyncData } from "../../../../core/models";
import {
  asyncItemReducerGenerator,
  generateCrudActionTypes,
  generateCrudReducers,
  generateCrudReduxActionCreators,
  IAsyncReduxAction,
  ICRUDActionTypes,
  ICrudReduxActionCreators,
  ICRUDReduxState,
} from "../../../../core/redux";
import { IClientHistory } from "../../data/entities";
import { ClientHistoryRepoImpl } from "../../data/repo";

const moduleName = "ClientHistory";

interface IClientHistoryActionTypes extends ICRUDActionTypes {
  getHistoryList: string;
}

const actionTypes: IClientHistoryActionTypes = {
  ...generateCrudActionTypes(moduleName),
  getHistoryList: `GET_${moduleName}_LAST_LIST`,
};

interface IClientHistoryActionCreators extends ICrudReduxActionCreators<IClientHistory, {}> {
  getHistoryList: (searchQuery?: string) => IAsyncReduxAction<IClientHistory[]>;
}

export const clientHistoryReduxActions: IClientHistoryActionCreators = {
  ...generateCrudReduxActionCreators<IClientHistory, {}>({
    actionTypes,
    repository: ClientHistoryRepoImpl,
  }),
  getHistoryList: (searchQuery) => ({
    type: actionTypes.getHistoryList,
    payload: ClientHistoryRepoImpl.getHistoryList(searchQuery),
  }),
};

export interface IClientHistoryReduxState extends ICRUDReduxState<IClientHistory> {
  historyList: IAsyncData<IClientHistory[]>;
}

export const ClientHistoryReducers = combineReducers<IClientHistoryReduxState>({
  ...generateCrudReducers<IClientHistory>(actionTypes),
  historyList: asyncItemReducerGenerator<IClientHistory[]>(actionTypes.getHistoryList),
});
